import OrdersEntity from '@/entities/api/orders/orders'
import DateConvert from '@/utils/date-convert'
import { OrderStatusColor, OrderStatusConvert } from '@/utils/order-status'
import { PaymethodsConvert } from '@/utils/paymethods-convert'
import formatCurrency from '@/utils/price-convert'
import {
	Box,
	Text,
	Badge,
	Flex,
	VStack,
	HStack,
	Separator,
} from '@chakra-ui/react'

const OrderCard = ({
	click,
	order,
}: {
	click: () => void
	order: OrdersEntity
}) => {
	return (
		<Box
			w='full'
			position='relative'
			borderWidth='1px'
			borderColor='gray.200'
			borderRadius='xl'
			overflow='hidden'
			p={4}
			mb={3}
			bg='white'
			cursor='pointer'
			transition='all 0.2s'
			_hover={{ boxShadow: 'md', transform: 'translateY(-1px)' }}
			onClick={click}
		>
			<Flex justify='space-between' align='center' mb={3}>
				<Badge
					px={3}
					py={1}
					borderRadius='md'
					fontSize='sm'
					color='gray.600'
					bg='gray.100'
				>
					{DateConvert(order._created ?? '')}
				</Badge>

				<Badge
					px={3}
					py={1}
					borderRadius='md'
					fontSize='sm'
					bg={OrderStatusColor(order.status)}
					color='white'
				>
					{OrderStatusConvert(order.status)}
				</Badge>
			</Flex>

			<VStack align='start' gap={2} mb={4}>
				<HStack>
					<Text fontWeight='bold' fontSize='lg' color='gray.800'>
						{order?.code ?? 'N/A'}
					</Text>
					<Badge colorScheme='blue' size='sm'>
						{Array.isArray(order?.products) && order.products.length > 0
							? order.products.reduce(
									(total, product) =>
										total +
										(Array.isArray(product?.attributes)
											? product.attributes.reduce(
													(attrTotal, attr) =>
														attrTotal + (attr?.quantity || 0),
													0
											  )
											: 0),
									0
							  )
							: 0}{' '}
						items
					</Badge>
				</HStack>

				<Text fontSize='sm' color='gray.600'>
					<strong>Cliente:</strong> {order?.customer?.name ?? 'N/A'}{' '}
					{order?.customer?.lastname ?? ''}
				</Text>

				<Text fontSize='sm' color='gray.600'>
					<strong>Pago:</strong>{' '}
					{PaymethodsConvert(order?.payment_info?.paymethod) ?? 'N/A'}
				</Text>
			</VStack>

			<Separator mb={4} borderColor='gray.200' />

			<VStack align='stretch' gap={2}>
				<Flex justify='space-between'>
					<Text fontSize='sm' color='gray.600'>
						Subtotal:
					</Text>
					<Text fontSize='sm' fontWeight='medium'>
						{formatCurrency(
							(Array.isArray(order?.products) && order.products.length > 0
								? order.products.reduce(
										(total, product) => total + (product?.subtotal || 0),
										0
								  )
								: 0
							).toFixed(2)
						)}
					</Text>
				</Flex>

				{Array.isArray(order?.products) &&
					order.products.length > 0 &&
					order.products.reduce(
						(total, product) => total + (product?.totalDiscount || 0),
						0
					) > 0 && (
						<Flex justify='space-between'>
							<Text fontSize='sm' color='red.500'>
								Descuento:
							</Text>
							<Text fontSize='sm' color='red.500' fontWeight='medium'>
								-
								{formatCurrency(
									order.products
										.reduce(
											(total, product) => total + (product?.totalDiscount || 0),
											0
										)
										.toFixed(2)
								)}
							</Text>
						</Flex>
					)}

				{Array.isArray(order?.products) &&
					order.products.length > 0 &&
					order.products.reduce(
						(total, product) => total + (product?.totalShipping || 0),
						0
					) > 0 && (
						<Flex justify='space-between'>
							<Text fontSize='sm' color='gray.600'>
								Envío:
							</Text>
							<Text fontSize='sm' fontWeight='medium'>
								
								{formatCurrency(
									order.products
										.reduce(
											(total, product) =>
												total + (product?.totalShipping || 0),
											0
										)
										.toFixed(2)
								)}
							</Text>
						</Flex>
					)}

				<Separator borderColor='gray.200' />

				<Flex justify='space-between' align='center'>
					<Text fontSize='lg' fontWeight='bold' color='gray.800'>
						Total:
					</Text>
					<Text fontSize='xl' fontWeight='bold' color='green.600'>
						
						{formatCurrency(
							(Array.isArray(order?.products) && order.products.length > 0
								? order.products.reduce((total, product) => {
										const subtotal = product?.subtotal || 0
										const discounts = product?.totalDiscount || 0
										const shipping = product?.totalShipping || 0
										return total + subtotal - discounts + shipping
								  }, 0)
								: 0
							).toFixed(2)
						)}
					</Text>
				</Flex>
			</VStack>
		</Box>
	)
}

export default OrderCard
